<ion-header>
  <ion-toolbar>
    <ion-title>Відправити на пошту</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()" color="dark">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-item *ngIf="deliveryType == 'email'">
    <ion-input
      ngModel
      [formControl]="emailControl"
      placeholder="Вкажіть електронну адресу"
      type="email"
    ></ion-input>
    <ion-note slot="error">Ви ввели не корректну пошту</ion-note>
    <ion-note slot="helper">Вкажіть електронну адресу для відправки</ion-note>
  </ion-item>
  <ion-item *ngIf="deliveryType == 'sms'">
    <ion-label slot="start">
      <h1>380</h1>
    </ion-label>
    <ion-input
      ngModel
      [formControl]="phoneControl"
      placeholder="Вкажіть номер телефону"
      type="tel"
    ></ion-input>
    <ion-note slot="error">Ви ввели не корректний номер</ion-note>
    <ion-note slot="helper">Вкажіть номер телефону для відправки</ion-note>
  </ion-item>
  <ion-item lines="none">
    <ion-button
      slot="start"
      color="dark"
      fill="outline"
      shape="round"
      size="default"
      (click)="updateDeliveryType('email')"
    >
      Email
    </ion-button>
    <ion-button
      slot="start"
      color="dark"
      fill="outline"
      shape="round"
      size="default"
      (click)="updateDeliveryType('sms')"
    >
      Sms
    </ion-button>
    <ion-button
      slot="end"
      color="dark"
      fill="outline"
      shape="round"
      size="default"
      (click)="send()"
      [disabled]="loading"
    >
      <ion-icon slot="start" name="send-outline"></ion-icon>
      Відправити
      <span class="bg-loader ml-2" *ngIf="loading"></span>
    </ion-button>
  </ion-item>
</ion-content>
